export default {
  lazyLoadOffset: 200
}
